export enum ERoutePath {
  ROOT = '/',
  TABLE_STRUCTURE = '/custom-dictionary',
  CALCULATE = '/calculate',
  TENANT_MANAGER = '/tenant-manager',
  ABOUT = '/about',
  OFFICIAL_WEB_CONFIG = '/official-web-config'
}